import { createContext } from 'react'

const EvidenceContext = createContext({ evidenceId: null })

export default EvidenceContext
